import * as StringUtils from '../../utils/string-utils';
import { modalComponentModule } from '../modal/modal';
import dialogTemplate from './dialog.tpl.html';
import './dialog.less';
import { escapeHTML } from '../../utils/string-utils';
import { onConfirmComponentModule } from '../on-confirm/on-confirm';

const DIALOG_BUTTON_STYLES = {
  ok: 'primary',
  yes: 'primary',
  save: 'primary',
  discard: 'danger',
};

const DIALOG_CANCEL_BUTTONS = {
  cancel: true,
};

export const dialogComponentModule = angular
  .module('Q.components.dialog', [
    modalComponentModule,
    onConfirmComponentModule,
  ])

  .factory('dialogService', function ($modal, $sce) {
    function _open(msg, title, buttons, modalOptions = {}) {
      return $modal.open(
        angular.extend(
          {
            template: dialogTemplate,
            controller: 'DialogCtrl as dialog',
            windowClass: 'no-close-button',
            resolve: { opts: () => ({ msg, title, buttons }) },
          },
          modalOptions,
        ),
      ).result;
    }

    return {
      busyOverlay(msg, helpText) {
        let _msg = `<p><span class="loading-spinner loading-spinner-large"></span></p><h2>${escapeHTML(msg)}</h2>`;
        if (helpText) {
          _msg += `<p class="help-block">${escapeHTML(helpText)}</p>`;
        }
        return $modal.open({
          template: dialogTemplate,
          controller: 'DialogCtrl as dialog',
          windowClass: `no-close-button busy-overlay-dialog`,
          resolve: {
            opts: () => ({ msg: $sce.trustAsHtml(_msg), buttons: [] }),
          },
          backdrop: 'static',
          keyboard: false,
        });
      },
      alert: function (msg, title) {
        return _open(msg, title, ['OK']);
      },
      confirm: function (msg, title, buttons = ['No', 'Yes']) {
        return _open(msg, title, buttons);
      },
      save: function (msg, title, buttons = ['Cancel', 'Discard', 'Save']) {
        return _open(msg, title, buttons);
      },
      open: _open,
    };
  })

  .controller('DialogCtrl', function (opts, $modalInstance) {
    const ctrl = this;
    const { msg, title, buttons } = opts;
    ctrl.msg = msg;
    ctrl.title = title;
    ctrl.buttons = buttons.map(function (b, i) {
      if (angular.isString(b)) {
        b = { text: b };
      }
      if (!b.id) {
        b.id = StringUtils.slugify(b.text);
      }
      if (!b.style) {
        b.style = DIALOG_BUTTON_STYLES[b.id] || 'default';
      }
      if (!b.isCancel) {
        b.isCancel = DIALOG_CANCEL_BUTTONS[b.id];
      }
      b.index = i;
      return b;
    });

    ctrl.click = function (btn) {
      if (btn.isCancel) {
        $modalInstance.dismiss(btn);
      } else {
        $modalInstance.close(btn);
      }
    };
  });
